import { render, staticRenderFns } from "./SalaryPolicyForm.vue?vue&type=template&id=e5f50b7a"
import script from "./SalaryPolicyForm.vue?vue&type=script&lang=js"
export * from "./SalaryPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports